import React, { useEffect } from "react";
import { RichText, Text, Link } from "@sitecore-jss/sitecore-jss-react";
import {
  KeepInTouchProps,
  SocialLink as SocialLinkType,
} from "./fields.definitions";
import { KeepInTouchModel } from "./fields.model";
import LazySection from "../../react-only-components/LazySection";
import "./index.scss";

const KeepInTouch = (props: KeepInTouchProps) => {
  const model = new KeepInTouchModel(props);
  const socialText = model.showForm?.value
    ? "social__text social__text--with-form"
    : "social__text";

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  return (
    <LazySection>
      <div className="keep-in-touch-wrapper" id={props?.rendering?.uid}>
        <div className="keep-in-touch-wrapper__content">
          <div className="keep-in-touch pfe-l-grid pfe-m-gutters pfe-m-all-6-col-on-md">
            <div className="keep-in-touch__content">
              <Text tag="h2" field={model.title} />
              {model.showForm.value && (
                <>
                  <RichText tag="div" field={model.content} />
                  <KeepInTouchForm />
                </>
              )}
            </div>
            <div className="social">
              <div className={socialText}>
                <Text tag="p" field={model.socialMediaTitle} />
              </div>
              <div className="social__links-container">
                {model.socialMediaLinks.map((item, i) => (
                  <SocialLink key={i} {...item} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LazySection>
  );
};

const SocialLink = ({ fields }: SocialLinkType) => (
  <Link field={fields.Link} className="social__link">
    <pfe-icon icon={fields.Icon.value} color="accent" size="24" />
  </Link>
);

const KeepInTouchForm = () => (
  <form className="keep-in-touch__form">
    <input
      type="email"
      placeholder="E-mail address"
      className="keep-in-touch__form-input"
    />
    <input type="submit" className="keep-in-touch__form-submit" />
  </form>
);

export default KeepInTouch;
